import script from "./FormNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./FormNumberInput.vue?vue&type=style&index=0&id=000308d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000308d2"]])

export default __exports__